<template>
    <div>
        <a-button type="primary" icon="plus" @click="addDoctor">添加研究者</a-button>
        <Divider style="margin-bottom: 32px;" />
        <a-table :columns="columns" :dataSource="data" bordered>
            <div
                    slot="filterDropdown"
                    slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                    style="padding: 8px"
            >
                <a-input
                        v-ant-ref="c => searchInput = c"
                        :placeholder="`Search ${column.dataIndex}`"
                        :value="selectedKeys[0]"
                        @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                        @pressEnter="() => handleSearch(selectedKeys, confirm)"
                        style="width: 188px; margin-bottom: 8px; display: block;"
                />
                <a-button
                        type="primary"
                        @click="() => handleSearch(selectedKeys, confirm)"
                        icon="search"
                        size="small"
                        style="width: 90px; margin-right: 8px"
                >搜索
                </a-button
                >
                <a-button @click="() => handleReset(clearFilters)" size="small" style="width: 90px"
                >重置
                </a-button
                >
            </div>
            <a-icon
                    slot="filterIcon"
                    slot-scope="filtered"
                    type="search"
                    :style="{ color: filtered ? '#108ee9' : undefined }"
            />


            <template
                    v-for="col in ['name', 'age']"
                    :slot="col"
                    slot-scope="text, record, index"
            >
                <div :key="col">
                    <a-input
                            v-if="record.editable"
                            style="margin: -5px 0"
                            :value="text"
                            @change="e => handleChange(e.target.value, record.key, col)"
                    />
                    <template v-else
                    >{{text}}
                    </template
                    >
                </div>
            </template>
            <template slot="operation" slot-scope="text, record">
                <a-popconfirm
                    title="确定将该医生从项目中踢出?"
                    @confirm="() => onDelete(record.key)"
                >
                    <a href="javascript:;">剔出</a>
                </a-popconfirm>
            </template>
        </a-table>

    </div>
</template>
<script>
    import request from "../../utils/request";
    import DescriptionList from "../../components/DescriptionList";
    import { Divider, Card } from "ant-design-vue";
    const { Description } = DescriptionList;

    const columns = [
        {
            title: '姓名',
            dataIndex: 'name',
            width: '10%',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                customRender: 'customRender',
            },
            onFilter: (value, record) => record.name.toString().toLowerCase().includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
                if (visible) {
                    setTimeout(() => {
                        this.searchInput.focus();
                    }, 0);
                }
            },
        },
        {
            title: '手机号',
            dataIndex: 'phone',
            width: '30%',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                customRender: 'customRender',
            },
            onFilter: (value, record) => record.phone.toString().toLowerCase().includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
                if (visible) {
                    setTimeout(() => {
                        this.searchInput.focus();
                    }, 0);
                }
            },
        },
        {
            title: '身份证',
            dataIndex: 'id_code',
            width: '10%',
        },
        {
            title: '医生是否激活',
            dataIndex: 'review',
            width: '10%',
        },
        {
            title: '操作',
            width: '10%',
            dataIndex: 'operation',
            scopedSlots: {customRender: 'operation'},
        },
    ];

    export default {
        components: {
            DescriptionList,
            Description,
            Divider,
            Card
        },
        data() {
            return {
                data: [],
                columns,
                searchText: '',
                searchInput: null,
            };
        },
        mounted() {
            this.getData();
        },
        methods: {
            getData() {
                request({
                    url: "/project_doctor/all/" + this.$route.query.the_id + "/",
                    method: "get",
                    params: {}
                }).then(response => {
                    console.log("获取到的参数", response.data.data);
                    if (response.data.success) {
                        this.data = response.data.data;
                    } else {
                        this.$message.error(response.data.msg)
                    }
                });
            },
            handleSearch(selectedKeys, confirm) {
                confirm();
                this.searchText = selectedKeys[0];
            },

            handleReset(clearFilters) {
                clearFilters();
                this.searchText = '';
            },
            onDelete(key) {
                request({
                    url: "/project_doctor/delete/" + this.$route.query.the_id + "/",
                    method: "delete",
                    params: {
                        doctor_id:key
                    }
                }).then(response => {
                    console.log("111");
                    if (response.data.success) {
                        this.getData();
                    } else {
                        this.$message.error(response.data.msg);
                    }
                });
            },
            getBack(key) {
                request({
                    url: "/project/getback/" + key,
                    method: "put",
                    params: {}
                }).then(response => {
                    this.getData();
                });
            },
            handleChange(value, key, column) {
                const newData = [...this.data];
                const target = newData.filter(item => key === item.key)[0];
                if (target) {
                    target[column] = value;
                    this.data = newData;
                }
            },
            goDetail(key) {
                this.$router.push({path: '/project/detail', query: {the_id: key,project_id:this.$route.query.the_id}})
            },
            addDoctor(){
                this.$router.push({path:'/project/add/doctor', query: {the_id:this.$route.query.the_id}});
            },
            save(key) {
                const newData = [...this.data];
                const newCacheData = [...this.cacheData];
                const target = newData.filter(item => key === item.key)[0];
                const targetCache = newCacheData.filter(item => key === item.key)[0];
                if (target && targetCache) {
                    delete target.editable;
                    this.data = newData;
                    Object.assign(
                        targetCache,
                        target
                    );
                    this.cacheData = newCacheData;
                }
            },
            cancel(key) {
                const newData = [...this.data];
                const target = newData.filter(item => key === item.key)[0];
                if (target) {
                    Object.assign(target, this.cacheData.filter(item => key === item.key)[0]);
                    delete target.editable;
                    this.data = newData;
                }
            },
        },
    };
</script>
<style scoped>
    .editable-row-operations a {
        margin-right: 8px;
    }
</style>